module.exports = __webpack_public_path__ + "img/Koda_Beta_dark.888b1ac.svg";